/**
 * Provider-agnostic domain errors. Adapters (TickStar, future others) translate
 * their HTTP/protocol errors into one of these so the calling code stays
 * provider-neutral.
 */

export type PeppolErrorCode =
  | 'AUTH_FAILED'
  | 'PARTICIPANT_NOT_REGISTERED'
  | 'DOCUMENT_TYPE_NOT_SUPPORTED'
  | 'SBDH_INVALID'
  | 'SCHEMA_VALIDATION_FAILED'
  | 'TRANSACTION_NOT_FOUND'
  | 'ALREADY_ACKNOWLEDGED'
  | 'KYC_REQUIRED'
  | 'RATE_LIMITED'
  | 'PROVIDER_TIMEOUT'
  | 'PROVIDER_INTERNAL'
  | 'NETWORK_FAILURE'
  | 'UNKNOWN';

export interface PeppolErrorDetails {
  /** Raw error code from the provider, when available. */
  providerCode?: string;
  /** Pointer to documentation, e.g. tickstar.com/article/access-point-error-codes. */
  docsUrl?: string;
  /** Whether the caller should retry with backoff. */
  retryable?: boolean;
  /** Any additional context to surface in admin UIs. */
  context?: Record<string, unknown>;
}

export class PeppolProviderError extends Error {
  code: PeppolErrorCode;
  details: PeppolErrorDetails;

  constructor(code: PeppolErrorCode, message: string, details: PeppolErrorDetails = {}) {
    super(message);
    this.name = 'PeppolProviderError';
    this.code = code;
    this.details = details;
  }
}
